import React from 'react';
import { List } from '@smarterservices/smarter-ui';
import { BlockComponentProps, OrderedListBlock as OrderedListBlockType, ListItemBlock } from '../../types';
import { formatText } from '../../utils/textFormatter';

/**
 * OrderedListBlock component renders a numbered (ordered) list
 * 
 * @param {BlockComponentProps<OrderedListBlockType>} props - Component props
 * @returns {React.ReactElement} Rendered ordered list
 */
export const OrderedListBlock = ({ block }: BlockComponentProps<OrderedListBlockType>) => {
  if (!block.items || !Array.isArray(block.items) || block.items.length === 0) {
    return null;
  }
  return (
    <List as="ol" margin={block.margin || "none"}>
      {block.items.map((item: ListItemBlock, index: number) => (
        <List.Item 
          key={`ordered-item-${index}`}
          margin="x-small 0"
        >
          {formatText(item.text, block.replacements)}
        </List.Item>
      ))}
    </List>
  );
};

export default OrderedListBlock;
